import { render, staticRenderFns } from "./VxCellIcon.vue?vue&type=template&id=7cfd9d5b&"
import script from "./VxCellIcon.vue?vue&type=script&lang=js&"
export * from "./VxCellIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports